import { useAuth } from './auth/AuthProvider';
import { Dashboard } from './components/Dashboard';
import { Login } from './components/Login';
import { useData } from './data/useData';

function StateCard({ message, onRetry }: { message: string; onRetry?: () => void }) {
  return (
    <div className="cw-fullcenter">
      <div className="cw-state-card">
        <div className="msg">{message}</div>
        {onRetry && (
          <button className="retry" onClick={onRetry}>
            Erneut versuchen
          </button>
        )}
      </div>
    </div>
  );
}

export function App() {
  const { status, user, signOut } = useAuth();
  const { data, loading, error, reload } = useData();

  if (status === 'loading') return <StateCard message="Lädt …" />;
  if (status === 'signedOut') return <Login />;

  // signedIn
  if (error) return <StateCard message={`Daten konnten nicht geladen werden: ${error}`} onRetry={reload} />;
  if (loading || !data) return <StateCard message="Daten werden geladen …" />;

  return <Dashboard data={data} user={user} onSignOut={signOut} />;
}
